import gql from 'graphql-tag';

export default gql`
  mutation saveScholarships($input: saveScholarshipsInput!) {
    saveScholarship(input: $input){
      viewer {
        scholarships {
          id
          url
          addInfo
          meritBasedScholarships {
            name
            awardType
            awAmountMin
            awAmountMax
            renewable
            gpaMin
            gpaMax
            gpaRankMatch
            classRankMin
            classRankMax
            satGpaMatch
            satMin
            satMax
            satActMatch
            actMin
            actMax
            audience
            audienceStates
          }
        }
      }
   }
  }
`;
